<div style="width: 100%">
  <div><strong>Upload PDF file</strong></div>
  <ngx-file-drop
    [accept]="acceptedFileTypes?.toString()"
    [multiple]="multiple"
    dropZoneClassName="uploaderDropZone"
    (onFileDrop)="fileDropped($event)"
  >
    <ng-template
      ngx-file-drop-content-tmp
      let-openFileSelector="openFileSelector"
    >
      <div
        class="uploaderClick"
        fxLayoutAlign="center center"
        fxLayout="row"
        (click)="openFileSelector()"
      >
        <div
          fxLayoutAlign="center center"
          fxLayout="row"
          fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
        >
          <div>
            Drag and drop or<br />
            click to upload
          </div>
          <mat-icon>cloud_upload</mat-icon>
        </div>
      </div>
    </ng-template>
  </ngx-file-drop>
</div>
<div class="error" *ngFor="let e of errors">{{ e.message }}</div>
